import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ClientItemDto } from '@common/generated-api/models/client-item-dto';
import { DeviceListDto } from '@common/generated-api/models/device-list-dto';
import { DistributorItemDto } from '@common/generated-api/models/distributor-item-dto';
import { ClientsService } from '@shared/services/clients.service';
import { DeviceStatusType } from '@shared/services/device-static-data.service';
import { DistributorsService } from '@shared/services/distributors.service';
import { CompanyTypes } from '@shared/types/api-types';
import { Merge } from '@shared/types/type.utils';
import { Observable, of } from 'rxjs';
import { startWith } from 'rxjs/operators';

@Component({
  selector: 'app-company-info',
  templateUrl: './company-info.component.html',
  styleUrls: ['./company-info.component.scss']
})
export class CompanyInfoComponent implements OnInit {
  @Input() clientId: number;
  @Input() distributorId: number;
  @Input() infoType: 'client' | 'distributor' = 'client';
  @Output() closeModal = new EventEmitter();

  companyUrl: string;
  companyType: DeviceStatusType;
  companyPreviewData$: Observable<DistributorItemDto> | Observable<Merge<ClientItemDto, { notes: string }>>;

  constructor(
    private clientsService: ClientsService,
    private distributorsService: DistributorsService,
  ) {
    this.companyPreviewData$ = of({});
  }

  ngOnInit(): void {
    let source;
    if (this.infoType === 'client' && this.clientId) {
      source = this.clientsService.getClient(this.clientId);
      this.companyType = CompanyTypes.CLIENT;
      this.companyUrl = '/cp/clients/' + this.clientId;
    } else if (this.infoType === 'distributor' && this.distributorId) {
      source = this.distributorsService.getDistributor(this.distributorId);
      this.companyType = CompanyTypes.DISTRIBUTOR;
      this.companyUrl = '/cp/distributors/' + this.distributorId;
    } else {
      console.error('Unsupported company type');
      return;
    }

    this.companyPreviewData$ = source.pipe(
      startWith({})
    );
  }
}
